import styles from "./Error.module.css";

const Error = () => {
  return <div className={styles.content}></div>;
};

export default Error;
